import React from "react";
import DeckCard from "./DeckCard";
import { fixedState } from "./DecksState";
import { BaseURL } from "../components/Common";

function DeckSelection({ deckState, updateDeckState }) {
    const updateState = ({ selected }) => {
        // Update the state using the updateDeckState function
        updateDeckState({
            ...deckState,
            deckStructure: {
                ...deckState.deckStructure, // Spread the existing deckStructure
                deckShape: selected, // Update the deckShape property
            },
            // You can add other properties here if needed
        });
    };

    return (
        <div style={{ padding: 20 }}>
            <div>
                <h2 style={{ margin: 0 }}>Lets get started!</h2>
                <p>To start, please select the decking shape.🔶</p>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
                <DeckCard
                    src={BaseURL("images/Sshape.png")}
                    title={fixedState.deckStructure.deckShape[0]}
                    description={"Decking Shape: Rectange or square"}
                    onClick={() => updateState({ selected: fixedState.deckStructure.deckShape[0] })}
                    selected={deckState.deckStructure.deckShape === fixedState.deckStructure.deckShape[0]}
                />
                <DeckCard
                    src={BaseURL("images/Lshape.png")}
                    title={fixedState.deckStructure.deckShape[1]}
                    description={"Decking Shape: L Structure"}
                    onClick={() => updateState({ selected: fixedState.deckStructure.deckShape[1] })}
                    selected={deckState.deckStructure.deckShape === fixedState.deckStructure.deckShape[1]}
                />
            </div>
        </div>
    );
}

export default DeckSelection;
